<template>
  <div :style="style">
    <div v-if="mode==ALBUM_TILE">
      <div v-for="image in files" :key="image.id">
        <img class="picture" :src='filename(image.file)' v-if="image.type==MEDIA_STATIC" />
        <img class="picture" src="@/assets/images/variable.webp" v-if="image.type==MEDIA_VARIABLE" />
      </div>
    </div>
    <div v-if="mode==ALBUM_TILE_MARGIN">
      <div v-for="image in files" :key="image.id">
        <img class="picture-margin" :src='filename(image.file)' v-if="image.type==MEDIA_STATIC" />
        <img class="picture-margin" src="@/assets/images/variable.webp" v-if="image.type==MEDIA_VARIABLE" />
      </div>
    </div>
    <div v-if="mode==ALBUM_SLIDE">
      <Carousel :value="files" :numVisible="1" :showNavigators="false">
          <template #item="image">
            <img class="picture" :src='filename(image.data.file)' v-if="image.data.type==MEDIA_STATIC" />
            <img class="picture" src="@/assets/images/variable.webp" v-if="image.data.type==MEDIA_VARIABLE" />
          </template>
      </Carousel>
    </div>
    <div v-if="mode==ALBUM_GALLERIA">
      <Galleria :value="files" :numVisible="3">
          <template #item="image">
            <img class="picture" :src='filename(image.item.file)' v-if="image.item.type==MEDIA_STATIC" />
            <img class="picture" src="@/assets/images/variable.webp" v-if="image.type==MEDIA_VARIABLE" />
          </template>
          <template #thumbnail="image">
            <img class="galleria-picture" :src='filename(image.item.file)' v-if="image.item.type==MEDIA_STATIC" />
            <img class="galleria-picture" src="@/assets/images/variable.webp" v-if="image.type==MEDIA_VARIABLE" />
          </template>
      </Galleria>
    </div>
  </div>
</template>

<script>
import Carousel from 'primevue/carousel';
import Galleria from 'primevue/galleria';
export default {
  name: 'ImagesComponent',
  components: {
    Carousel,
    Galleria
  },
  data(){
    return {
      style:'',
      timerId:null,
      carouselheight:'300px',
      mode:0,
      files:[],
      ALBUM_TILE:1,
      ALBUM_TILE_MARGIN:2,
      ALBUM_SLIDE:3,
      ALBUM_GALLERIA:4,
      MEDIA_STATIC:1,
      MEDIA_VARIABLE:2
    }
  },
  props: {
    component: null
  },
  methods:{
    updateCarouselHeight(){

      /*if(this.$refs.imgHeight===undefined)
        return;

      var carouselheight = this.$refs.imgHeight[0].height;

      var carouselwidth = this.$refs.imgHeight[0].width;

      var conatinerwidth = this.$refs.cacontainer.clientWidth;

      if(conatinerwidth>0&&carouselheight>0&&carouselwidth>0)
        this.carouselheight=conatinerwidth*(carouselheight/carouselwidth)+'px';

      clearInterval(this.timerId);*/

    },
    filename(file){
      return this.$common.HOST+"/resources/"+file.filename
    }
  },
  updated(){

    

  },
  mounted(){

    /*if(this.mode==this.ALBUM_SLIDE&&this.files){

      this.timerId=setInterval(()=>{this.updateCarouselHeight()},1000);

    }*/

  },
  created(){
    
    this.style=this.$common.generateStyle(this.component.data.style);

    this.mode=this.component.data.data.mode;

    this.files=this.component.data.data.files;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.picture{
    width: 100%;
    display: block;
}

.galleria-picture{
  width:90%;
  display: block;
}

.picture-margin{
    width: 100%;
    margin-bottom: 10px !important;
    display: block;
}

.picture-margin:last-child{
    margin-bottom: 0px;
}
</style>
